import { cn } from "@/lib/cn";

/** A thin horizontal meter, 0-100. */
export function Meter({
  value,
  className,
  barClassName,
  label,
}: {
  value: number | null | undefined;
  className?: string;
  barClassName?: string;
  label: string;
}) {
  const v = typeof value === "number" && Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;
  return (
    <div
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(v)}
      className={cn("h-1.5 w-full overflow-hidden rounded-full bg-surface-3", className)}
    >
      <div className={cn("h-full rounded-full bg-brand transition-[width]", barClassName)} style={{ width: `${v}%` }} />
    </div>
  );
}
